import { api } from './client';
import type { Product } from './types';

export function listProducts(): Promise<{ products: Product[] }> {
  return api.get(`/api/v1/products`);
}
